module.exports = __webpack_public_path__ + "static/img/home7.0262c841.png";